export const PERMISSIONS = {
  USER: {
    VIEW: 'User:view',
    PAUSE: 'User:pause',
    EDIT: 'User:edit',
    DELETE: 'User:delete',
    CREATE: 'User:create',
    CAN_EDIT_ADMIN: 'User:can_edit_admin',
    CAN_DELETE_ADMIN: 'User:can_delete_admin',
    VIEW_ALL: 'User:view_all',
  },
  OFFER: {
    VIEW: 'Offer:view',
    PAUSE: 'Offer:pause',
    EDIT: 'Offer:edit',
    DELETE: 'Offer:delete',
    CREATE: 'Offer:create',
    CLOSE: 'Offer:close',
  },
  ENTITY: {
    VIEW_ALL: 'Entity:view_all',
    VIEW: 'Entity:view',
    EDIT: 'Entity:edit',
    CAN_EDIT_DATA_MANAGEMENT: 'Entity:can_edit_data_management',
  },
  ENTITY_LOCATION: {
    VIEW: 'EntityLocation:view',
    CREATE: 'EntityLocation:create',
    EDIT: 'EntityLocation:edit',
    DELETE: 'EntityLocation:delete',
  },
  APPLY_OFFER: {
    VIEW: 'ApplyOffer:view',
    EDIT: 'ApplyOffer:edit',
    DELETE: 'ApplyOffer:delete',
  },
  USER_ACTION_LOG: { VIEW_ALL: 'UserActionLog:view_all' },
} as const;

type PermissionGroups = typeof PERMISSIONS;
type PermissionValue<T> = T extends Record<keyof T, infer Inner>
  ? Inner extends string
    ? Inner
    : never
  : never;

export type DefinedPermission = PermissionValue<PermissionGroups[keyof PermissionGroups]>;

export interface Permission {
  resource: string;
  action: string;
}

export interface PermissionsResponse {
  data: {
    [key: string]: Permission;
  };
}

export enum GROUP_USER_PERMISSIONS {
  OWNER = 'owner',
  ADMIN = 'admin',
  PUBLISHER = 'publisher',
  CANDIDATE_MANAGER = 'candidate_manager',
  PUBLISHER_CANDIDATE_MANAGER = 'publisher_candidate_manager',
  GUEST = 'guest',
  PLATFORM_ADMIN = 'platform_admin',
  PLATFORM = 'platform'
}
